export default __webpack_public_path__ + "img/d6fd6fc26775b0db7605be3ae69097bc.png";